import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadingComponent implements OnInit {
  @Input() message: string
  @Input() spinnerType: string
  @Input() cssClass: string
  @Input() showBackdrop: boolean = true

  constructor() {}

  ngOnInit() {}
}
